import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { Email } from '../shared/email.model';
import { MyLocalStorageService } from '../localstorage/mylocalstorage.service';
import { AuthService } from '../auth.service';
import {FormControl, Validators} from '@angular/forms';
import {DateAdapter} from '@angular/material/core';
@Component({
  selector: 'app-ferie-un-giorno',
  templateUrl: './ferie-un-giorno.component.html',
  styleUrls: ['./ferie-un-giorno.component.scss']
})
export class FerieUnGiornoComponent implements OnInit {
  passwordFormControl = new FormControl('', [
    Validators.required
  ]);
  passwordFormControl1 = new FormControl('', [
    Validators.required
  ]);
  constructor(private _adapter: DateAdapter<any>, public _auth: AuthService, public _storage: MyLocalStorageService, private _router: Router,  private _service: NotificationsService) { }
  variabile_data: any;
  variabile_ora: any;
  tiporichiesta:any;
  variabile_orario_uscita: any;
  variabile_orario_rientro: any;
  concordato: any;
  company: any;
  setting: Email = new Email();
  ngOnInit() {
    this.tiporichiesta=localStorage.getItem('tiporichiesta').replace(/_/g, " ");
    this.company = localStorage.getItem('company');
    this._adapter.setLocale('it')
  }
  preview(){
    this._storage.setItem('data', this.variabile_data);
    this._storage.setItem('concordato', this.concordato);
    this._storage.setItem('ora', '8');
    this._storage.setItem('orario', null);
    this._storage.setItem('orario_ingresso', null);
    this._router.navigate(['/preview'], { skipLocationChange: true });
  }

}
